// Geometry shared by the SVG charts (dashboard KPIs and coverage rose, results KPIs).

/**
 * SVG path of a ring segment between radii r0 < r1, from angle a0 to a1 (radians, clockwise from 3 o'clock).
 */
export function arcPath(cx: number, cy: number, r0: number, r1: number, a0: number, a1: number): string {
  const end = a1 - a0 >= Math.PI * 2 - 1e-4 ? a0 + Math.PI * 2 - 1e-3 : a1;
  const p = (r: number, a: number) =>
    `${(cx + Math.cos(a) * r).toFixed(2)} ${(cy + Math.sin(a) * r).toFixed(2)}`;
  const large = end - a0 > Math.PI ? 1 : 0;
  return (
    `M${p(r1, a0)}A${r1} ${r1} 0 ${large} 1 ${p(r1, end)}` +
    `L${p(r0, end)}A${r0} ${r0} 0 ${large} 0 ${p(r0, a0)}Z`
  );
}

/**
 * Angles of the segments of a ring chart, starting at 12 o'clock: each value gets its share of the circle,
 * minus a gap. Zero values get no segment (null). The gap only applies when more than one segment shows.
 */
export function ringSegments(values: readonly number[], gap?: number): ({ a0: number; a1: number } | null)[] {
  const total = values.reduce((sum, v) => sum + v, 0) || 1;
  const g = gap ?? (values.filter((v) => v > 0).length > 1 ? 0.05 : 0);
  let a = -Math.PI / 2;
  return values.map((v) => {
    if (v <= 0) return null;
    const d = (v / total) * Math.PI * 2;
    const seg = { a0: a + g / 2, a1: a + d - g / 2 };
    a += d;
    return seg;
  });
}
